/**
 * Bandeau de citations des vignerons, défilement continu.
 * Réutilise le même Google Sheet que la galerie de portraits
 * (colonnes Prénom + Citation).
 */
(function () {
  function init(root) {
    var sheetUrl = root.dataset.sheetUrl;
    if (!sheetUrl || typeof Papa === "undefined") return;

    Papa.parse(sheetUrl, {
      download: true,
      header: true,
      skipEmptyLines: true,
      transformHeader: function (h) { return h.replace(/^\uFEFF/, "").trim(); },
      transform: function (v) { return typeof v === "string" ? v.trim() : v; },
      complete: function (results) {
        var rows = results.data.filter(function (r) {
          return r["Prénom"] && r["Citation"];
        });
        if (!rows.length) return;

        var itemsHtml = rows
          .map(function (r) {
            return (
              '<span class="ct-item"><span class="ct-quote">' +
              r["Citation"] +
              '</span><span class="ct-name">— ' +
              r["Prénom"] +
              '</span><span class="ct-dot">·</span></span>'
            );
          })
          .join("");

        // dupliqué une fois pour un défilement continu sans coupure
        var track = root.querySelector("[data-ct-track]");
        track.innerHTML = itemsHtml + itemsHtml;
      }
    });
  }

  document.querySelectorAll("[data-citations-vignerons]").forEach(init);
})();